import { Infinity } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function StatusBadge({ status }) {
  if (status === "permanent") {
    return (
      <Badge className="bg-gradient-to-r from-amber-500/20 to-amber-600/10 text-amber-400 border-amber-500/25 text-[10px] shadow-[0_0_8px_rgba(245,158,11,0.08)]">
        <Infinity className="w-2.5 h-2.5 mr-0.5" />
        Perm
      </Badge>
    );
  }
  if (status === "active") {
    return (
      <Badge className="bg-gradient-to-r from-emerald-500/20 to-emerald-600/10 text-emerald-400 border-emerald-500/25 text-[10px] shadow-[0_0_8px_rgba(52,211,153,0.08)]">
        Actif
      </Badge>
    );
  }
  return (
    <Badge className="bg-gradient-to-r from-red-500/20 to-red-600/10 text-red-400 border-red-500/25 text-[10px] shadow-[0_0_8px_rgba(239,68,68,0.08)]">
      Expiré
    </Badge>
  );
}
